export default __webpack_public_path__ + "static/media/Kutalia.13f66088.mp4";